// Global Cart Drawer Handler - Clean Version
document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart drawer handler loaded');
  
  // Intercept Add to Cart form submissions
  document.addEventListener('submit', function(e) {
    if (e.target.getAttribute('action')?.includes('/cart/add') || 
        e.target.classList.contains('product-form') ||
        e.target.getAttribute('data-type') === 'add-to-cart-form') {
      
      e.preventDefault();
      handleAddToCart(e.target);
    }
  });

  // Intercept cart icon clicks
  document.addEventListener('click', function(e) {
    const cartLink = e.target.closest('a[href="/cart"]');
    
    if (cartLink) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Cart link clicked');
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(cartLink);
      } else {
        console.error('Cart drawer not found or open method missing');
        window.location.href = '/cart';
      }
    }
  });

  async function handleAddToCart(form) {
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');
    
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerHTML = 'Adding...';
    }
    
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!addResponse.ok) throw new Error('Failed to add to cart');
      
      console.log('Product added to cart');
      
      const drawerResponse = await fetch('/cart?section_id=cart-drawer');
      const drawerHTML = await drawerResponse.text();
      
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({
          sections: {
            'cart-drawer': drawerHTML
          }
        });
        console.log('Cart drawer updated');
      } else {
        console.error('Cart drawer renderContents method not found');
        window.location.href = '/cart';
      }
      
    } catch (error) {
      console.error('Cart error:', error);
      alert('Error adding to cart. Redirecting...');
      window.location.href = '/cart';
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = 'Add to Cart';
      }
    }
  }
});